import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.map";
import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es6.string.small";

/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import hash from 'string-hash';
import { CHARLES_BLUE } from '../utilities/constants';
import { ToolTip } from './ToolTip';
/**
 * Stateless dropdown select component.
 *
 * Automatically generates an id for the element if one is not provided.
 *
 * If hideLabel is specified, the label text will be added as an aria-label
 * attribute on the select element.
 *
 * todo: at narrow widths, padding visually obscures current selection
 *
 * todo: currently assumes it will receive an array of strings to create its <option>s; there may be cases when we want an option to have a different value from its displayed text, and pass in an array of objects instead. - 9/21 jm
 */

export default function SelectDropdown(props) {
  var toolTip = props.toolTip;
  var id = props.id || "select-".concat(hash(props.label));
  var classNames = {
    label: "txt-l ".concat(props.small ? 'txt-l--sm' : ''),
    container: "sel-c ".concat(props.small ? 'sel-c--thin' : '', " ").concat(props.error ? 'sel-c--err' : ''),
    select: "sel-f ".concat(props.small ? 'sel-f--thin' : '', " ").concat(props.error ? 'sel-f--err' : '')
  };

  var opts = function opts(_options) {
    if (_typeof(_options[0]) === 'object') {
      return _options.map(function (option) {
        return jsx("option", {
          key: "".concat(id, "_").concat(option.value),
          value: option.value,
          css: OPT_STYLING
        }, option.label);
      });
    } else {
      return _options.map(function (option) {
        return jsx("option", {
          key: "".concat(id, "_").concat(option)
        }, option);
      });
    }
  };

  var optionalDescriptionElem = function optionalDescriptionElem(optionalDescription) {
    var cont = 'notice css-content-psedo';
    return jsx("label", {
      className: cont
    }, optionalDescription);
  };

  var requireStr = function requireStr() {
    var softRequired = props.softRequired;
    var retStr = "Required";

    if (typeof softRequired === 'boolean' && softRequired === false) {
      retStr = "Optional";
    }

    return retStr;
  };

  var cssObj_labelReq = {
    't--req': 't--req'
  };

  if (typeof props.softRequired === 'boolean' && props.softRequired === false) {
    cssObj_labelReq['t--opt'] = 't--opt';
  } // Filter out object key/value with empty strings eq. ``


  Object.keys(cssObj_labelReq).forEach(function (k) {
    return cssObj_labelReq[k] == '' && delete cssObj_labelReq[k];
  }); // Output obj values as string of classNames

  var cssArrToString = Object.keys(cssObj_labelReq).map(function (obj) {
    return cssObj_labelReq[obj];
  }).toString().replace(/,/g, ' ');

  var labelElem = function labelElem(label) {
    var modLabelStyle = {
      marginTop: '1em',
      marginBottom: '2em',
      display: 'flex'
    };
    var optStyles = props.labelBelowInput ? modLabelStyle : {
      display: 'flex'
    };
    var styleObj = {
      marginRight: '0.5em',
      display: 'flex'
    };

    if (!props.disableLabelNoWrap) {
      styleObj['whiteSpace'] = 'nowrap';
    }

    return jsx("label", {
      htmlFor: id,
      className: classNames.label,
      style: optStyles
    }, props.hideLabel ? jsx(React.Fragment, null, "\xA0") : jsx("span", {
      style: styleObj
    }, label), (props.required || typeof props.softRequired === 'boolean') && jsx("span", {
      className: "".concat(cssArrToString),
      style: {
        display: 'flex'
      }
    }, requireStr(), toolTip && ToolTip({
      icon: toolTip.icon,
      msg: toolTip.msg
    })));
  };

  var spacer = function spacer() {
    return jsx("div", {
      className: "t--subinfo t--err m-b100"
    }, props.error && typeof props.error === 'string' ? props.error : jsx(React.Fragment, null, "\xA0"));
  };

  return jsx("div", {
    className: props.className,
    style: props.style
  }, !props.labelBelowInput && labelElem(props.label), props.labelBelowInput && spacer(), props.optionalDescription && props.optionalDescription.length > 0 && optionalDescriptionElem(props.optionalDescription), jsx("div", {
    className: classNames.container
  }, jsx("select", {
    id: id,
    className: classNames.select,
    "aria-label": props.hideLabel ? props.label : '',
    name: props.name,
    value: props.value,
    defaultValue: props.defaultValue,
    disabled: props.disabled,
    required: props.required,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus
  }, !props.hideBlankOption && jsx("option", null), opts(props.options))), props.labelBelowInput && labelElem(props.label));
}
var OPT_STYLING = css("\n  color: ".concat(CHARLES_BLUE, ";\n"));